import { Progress } from 'antd';
import { t } from 'ttag';
import { getDuration } from './duration';
import type { DurationFormatterProps } from './types';

const DurationFormatter = ({
  progressValue = 0,
  isShowProgress = false,
  isUploadProgress = false,
  format = 'd[d] hh[h] mm[m]',
  duration,
}: DurationFormatterProps) =>
  isShowProgress ? (
    <>
      <div className="flex justify-between">
        {isUploadProgress ? (
          <>
            <span>{t`Uploading`}</span>
            <span>{`${progressValue}%`}</span>
          </>
        ) : (
          <>
            <span>{getDuration(duration, 'd [day]')}</span>
            <span>{`${progressValue}%`}</span>
          </>
        )}
      </div>
      <Progress
        className={`duration-progress-bar ${isUploadProgress ? 'progress-blue' : ''}`}
        showInfo={false}
        strokeColor={isUploadProgress ? '#0954ba' : '#00b268'}
        {...({ value: progressValue, color: '#879890' } as any)}
      />
    </>
  ) : (
    <span>{getDuration(duration, format, 'h')}</span>
  );

export default DurationFormatter;
